module.exports = __webpack_public_path__ + "static/media/Rowena_Portrait 1.a0376f14.jpg";